<div class="std-ta-center">
    <h3 nxHeadline="subsection-large" class="nx-margin-bottom-m">Warning</h3>
    <p nxCopytext="normal" class="nx-font-weight-light nx-margin-bottom-m">
        {{ message }}
    </p>
    <button nxModalClose nxButton="primary" type="button">
        OK
    </button>
</div>